/**
 * Format date for API calls (mm-dd-yyyy format)
 */
export const formatDateForAPI = (date: Date): string => {
  // Ensure we have a valid date and return proper format
  if (!date || Number.isNaN(date.getTime())) {
    // Fallback to today if date is invalid
    date = new Date();
  }
  
  // Format as mm-dd-yyyy
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${month}-${day}-${year}`;
};

/**
 * Format date for API calls with timezone (mm-dd-yyyy format)
 * Preserves the calendar date selected by the user regardless of timezone
 * Timezone is passed to API for server-side timezone handling
 */
export const formatDateForAPIWithTimezone = (date: Date, _timezone: string): string => {
  // Use the same formatting as base function to preserve calendar date
  // Timezone parameter is kept for API compatibility but not used in formatting
  // to prevent timezone-based date shifts
  return formatDateForAPI(date);
};

/**
 * Format date for calendar display - "Wed 11 Dec" format
 */
export const formatCalendarDate = (date: Date): string => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]}`;
};

/**
 * Get default formatted date string for today
 */
export const getDefaultDateString = (): string => {
  const today = new Date();
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${days[today.getDay()]}, ${months[today.getMonth()]} ${today.getDate()}, 2025`;
};
